<template lang="pug">
    app-modal(
      :closeOutside="false",
      titulo="Alteração de perfil",
      :width="1000",
      @closeModal="closeModal()",
    )
      template(slot="body")
        validation-observer.margin-top(ref='observer' tag='form' v-if="usuario")
          app-input-perfil.no-padding(
            v-model="perfis",
            :usuarioTipo="usuario.pessoa.tipo",
            :pessoa="usuario.pessoa",
          )
          div(v-if="hasInserirMunicipio").margin-top
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(label="Município:")
              el-select.full-width.input(
                filterable
                v-model='idMunicipio'
                :class="{'erro' : errors.length}"
              )
                el-option(
                    v-for='municipio in municipios'
                    :key='municipio.id',
                    :label='municipio.nome'
                    :value='municipio.id'
                )
              span.help.erro {{ errors[0] }}
          el-col.margin-top(:span="24")
            validation-provider(rules="required", v-slot="{ errors }", name="observacao")
              app-label(
                label="Observação:",
                :required="true"
              )
              el-input.input(
                type="textarea"
                placeholder="Observação..."
                :class="{'erro' : errors.length}",
                v-model="observacao"
              )
              span.help.erro {{ errors[0] }}
          el-col.margin-top-30(:span="24")
            validation-provider(rules="", v-slot="{ errors }", name="arquivo")
              app-label(label="Anexo:", :required="false")
              app-upload-area(
                id="modalAlterarPerfil"
                :target="urlUpload"
                :fileType="validExtensions"
                v-model="documento"
                :onSuccess="onSuccess"
                @removerDocumento="removeArquivo"
                :errors="errors"
                :hasDownloadButton="false"
              )
      template(slot="footer")
        div.buttons
          el-button.cancelarButton(@click="closeModal()")
            i.fas.fa-times
            |  Cancelar
          el-button(type="primary",key="botao-confirma",@click="save()")
            i.fas.fa-check
            |  Confirmar
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppInputPerfil from '@/screens/portal/seguranca/components/AppInputPerfil.vue'
import AppUploadArea from '@/components/AppUploadArea'

export default {
  components: {
    AppModal,
    AppLabel,
    AppInputPerfil,
    AppUploadArea
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      documento: null,
      observacao: '',
      perfis: [],
      validExtensions: ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'],
      perfisInserirrMunicipio: ['TECNICO_MUNICIPAL', 'TECNICO_MUNICIPAL_RELATORIO', 'PREFEITO', 'JURIDICO_MUNICIPAL', 'GESTOR_MUNICIPAL', 'CARTORARIO', 'ADMINISTRATIVO', 'ADMINISTRATIVO_VISUALIZACAO', 'SECRETARIO_MUNICIPAL'],
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      usuario: null,
      municipios: [],
      idMunicipio: null
    }
  },

  props: {
    cpfCnpj: {
      type: String,
      required: true
    }
  },

  async created () {
    this.usuario = await this.findUsuarioByCpfCnpj(this.cpfCnpj)
    this.perfis = _.cloneDeep(this.usuario.perfis)
    if (this.usuario?.municipioPrefeitura) {
      this.idMunicipio = this.usuario?.municipioPrefeitura?.id
    }
    this.municipios = await this.findMunicipiosByEstadoAtual() || []
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/user'
    }),

    perfisIsEmpty () {
      return !this.usuario.perfis || this.usuario.perfis.length === 0
    },

    perfisTouched () {
      return this.perfisSelecionados.length === 0 && this.perfisExcluidos.length === 0
    },

    hasInserirMunicipio () {
      return this.perfis.find(perfil => this.perfisInserirrMunicipio.includes(perfil.codigo))
    }

  },

  methods: {
    ...mapActions({
      alterarPerfis: 'usuario/alterarPerfis',
      findUsuarioByCpfCnpj: 'usuario/findUsuarioByCpfCnpj',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtualPromise'
    }),

    onSuccess (id, resumableFile, fileKey) {
      this.documento = {
        key: fileKey,
        nome: resumableFile.fileName,
        tipo: {
          id: 1
        }
      }
    },

    closeModal () {
      this.isCamposModal = true
      this.$emit('closeModal')
    },

    removeArquivo () {
      this.documento = undefined
    },

    async save () {
      if (!await this.$refs.observer.validate()) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.PREENCHA_TODOS_CAMPOS)
        return
      }

      if ((this.usuario?.municipioPrefeitura?.id === null || this.usuario?.municipioPrefeitura?.id === this.idMunicipio) && JSON.stringify(this.usuario.perfis) === JSON.stringify(this.perfis)) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.PERFIL_SEM_ALTERACAO)
        return
      }

      if (this.usuario.perfis) {
        try {
          await this.alterarPerfis({
            idMunicipioPrefeitura: this.idMunicipio,
            observacao: this.observacao,
            documento: this.documento,
            loginUsuario: this.usuario.pessoa.cpfCnpj,
            perfis: this.perfis,
            tipoHistorico: 'ALTERADO'
          })
          this.closeModal()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.ALTERACAO_SUCESSO)
        } catch (e) {
        }
      }
    }
  }

}
</script>

<style scoped lang="scss">
  .buttons {
    display: flex;
    justify-content: space-between;
  }

  .upload-margin {
    margin-top: 1rem;
    margin-bottom: -1rem;
  }

  .cancelarButton:hover, .cancelarButton:focus {
    background-color:#fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }

  .margin-top-30 {
    margin-top: 30px;
  }

  .margin-top {
    margin-top: 10px;
  }

  .margin-top-5 {
    margin-top: 5px;
  }

  .no-padding{
    padding: 0;
  }

  .margin-right {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalAlterarPerfil.vue